import { Loader2 } from "lucide-react";
import { cn } from "@/lib/utils";
import { ROLE_LABELS } from "@/lib/dates";

export const Logo = ({ light = false, compact = false }) => (
  <div className="flex items-center gap-2" data-testid="app-logo">
    <div className="h-9 w-9 rounded-xl bg-[#FF5A36] grid place-items-center text-white font-display font-extrabold text-lg shadow-sm">
      S
    </div>
    <span className={`font-display font-bold text-lg tracking-tight whitespace-nowrap ${compact ? "hidden min-[480px]:inline " : ""}${light ? "text-white" : "text-slate-900"}`}>
      ShiftMate <span className={light ? "text-[#FFB4A3]" : "text-[#0D5C46]"}>NL</span>
    </span>
  </div>
);

export const PageHeader = ({ title, subtitle, children }) => (
  <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-6 fade-up">
    <div>
      <h1 className="text-2xl sm:text-3xl lg:text-4xl font-extrabold tracking-tight text-slate-900" data-testid="page-title">
        {title}
      </h1>
      {subtitle && <p className="text-sm sm:text-base text-slate-500 mt-1">{subtitle}</p>}
    </div>
    {children && <div className="flex flex-wrap gap-2">{children}</div>}
  </div>
);

const ROLE_STYLE = {
  owner: "bg-[#0D5C46] text-white",
  manager: "bg-emerald-100 text-emerald-900",
  employee: "bg-slate-100 text-slate-700",
};

export const RoleBadge = ({ role }) => (
  <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold ${ROLE_STYLE[role]}`}>
    {ROLE_LABELS[role]}
  </span>
);

export const Avatar = ({ name = "?", size = "h-9 w-9" }) => {
  const initials = name.split(" ").map((p) => p[0]).slice(0, 2).join("").toUpperCase();
  return (
    <div className={`${size} shrink-0 rounded-full bg-[#E6F0EC] text-[#0D5C46] grid place-items-center text-xs font-bold`}>
      {initials}
    </div>
  );
};

export const Loader = ({ full = false }) => (
  <div className={`grid place-items-center ${full ? "min-h-screen" : "py-16"}`} data-testid="loader">
    <Loader2 className="h-7 w-7 animate-spin text-[#0D5C46]" />
  </div>
);

export const Empty = ({ icon: Icon, title, text, children }) => (
  <div className="rounded-2xl border border-dashed border-slate-300 bg-white/60 p-8 text-center" data-testid="empty-state">
    {Icon && <Icon className="mx-auto h-8 w-8 text-slate-400 mb-3" />}
    <p className="font-semibold text-slate-800">{title}</p>
    {text && <p className="text-sm text-slate-500 mt-1">{text}</p>}
    {children && <div className="mt-4">{children}</div>}
  </div>
);

export const Panel = ({ className = "", children, ...rest }) => (
  <div className={cn("rounded-2xl border border-slate-200/80 bg-white p-5 shadow-[0_1px_2px_rgba(15,23,42,0.04)]", className)} {...rest}>
    {children}
  </div>
);
